import { FieldProps } from 'formik'
import React from 'react'
import FormField, { FormFieldProps } from './form-field'
import FormulaBuilder from '../../employer-rules/employer-rules-form/formula-builder'
import { InputFormula } from '../../../api/employer-rules'
import { PathOption } from '../../employer-rules/employer-rules-form/types'

/**
 * Props for the InputFormulaField component
 */
interface InputFormulaFieldProps extends FormFieldProps, FieldProps {
  availablePaths: PathOption[]
  availableRules?: Array<{ value: string; label: string }>
  availableEvents?: Array<{ value: string; label: string }>
  disabled?: boolean
}

/**
 * Formik-compatible field component for InputFormula
 * Wraps the FormulaBuilder component with Formik integration
 */
const InputFormulaField: React.FunctionComponent<InputFormulaFieldProps> = props => {
  const { field, form, availablePaths, availableRules, availableEvents, disabled, ...rest } = props

  const handleChange = (formula: InputFormula | null) => {
    form.setFieldValue(field.name, formula)
  }

  const error = form?.errors[field?.name] as string

  return (
    <FormField
      label={props.label}
      error={error}
      help={props.help}
      required={rest.required}
      info={props.info}
    >
      <FormulaBuilder
        value={field.value as InputFormula | null}
        onChange={handleChange}
        availablePaths={availablePaths}
        availableRules={availableRules}
        availableEvents={availableEvents}
        disabled={disabled}
        error={error}
      />
    </FormField>
  )
}

export default InputFormulaField
